import {
  isRiskAnalysisFlow,
  isSalesConversationFlow,
} from '@common/src/utils/globalVariables';
import MaskedInputComponent from '@flows/src/components/input/company-scan-inputs/masked/MaskedInputComponent';
import React from 'react';

// Types
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import MaskedInputComponentAdvisory from './MaskedInputComponent';

interface Props {
  question: FlowsQuestion;
}

const MaskedInputPicker: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  if (isRiskAnalysisFlow() || isSalesConversationFlow()) {
    return <MaskedInputComponentAdvisory question={question} />;
  }
  return <MaskedInputComponent question={question} />;
};

export default MaskedInputPicker;
